module.exports = __webpack_public_path__ + "img/kellys.8c013feb.svg";